import { render } from "./Home.vue?vue&type=template&id=14f78fb8"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=14f78fb8&lang=css"

import exportComponent from "F:\\PROJECTS\\2022\\school\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__